import { Article } from "../../../../shared/types"

type AlbumIndicationProps = {
    album: string[],
    currentPhoto: number
}

export default function AlbumIndication({album, currentPhoto}: AlbumIndicationProps) {
    const totalPages = album.length;
    let photos: number[] = [];

    const max = 5;
    const delta = Math.floor(max/2);

    let start = currentPhoto-delta;
    let end = currentPhoto+delta;

    if (start < 0) {
        start = 0;
    }

    if (end > totalPages-1) {
        end = (totalPages-1);
    }

    const length = end - start + 1;
    const someBefore = start - 1 > -1;
    const someAfter = end < totalPages-1;

    photos = Array.from({ length }, (_, i) => start + i);
    if (someBefore) {photos.unshift(1000);}
    if (someAfter) {photos.push(1000)}

    return (
        <div className="flex gap-2 items-center px-2 py-1 rounded-lg bg-black/80 transition-all ease-in-out duration-200">
            {photos.map((p,i) => {
                const current = currentPhoto == p;
                return (

                    <p className={`${((someBefore && p == 1000) || (someAfter && p == 1000)) ? 'h-1 w-1' : 'h-2 w-2'} rounded-full ${current ? 'bg-white' : 'bg-gray-500'} transition-all ease-in-out duration-200`}>
                    </p>
                )
            })

            }
        </div>
    )
}